export function isNumeric(num: unknown): num is number {
  return (
    (typeof num === 'number' || (typeof num === 'string' && num.trim() !== '')) &&
    !isNaN(num as number)
  )
}
